const ar = {
  home: 'الرئيسية',
  nextText: 'التالي',
  hijriShortcut: 'هـ',
  latinDateShortcut: 'م',
  cancelText: 'إلغاء',
  saveChanges: 'حفظ التغيرات',
  unAvailable: 'لا يوجد',
  newest: 'الأحدث',
  oldest: 'الاقدم',
  requests: 'الطلبات',
  or: 'أو',
  notExist: 'لا يوجد',
  dashboard: 'لوحة المعلومات',
  judicialLicenses: 'التراخيص العدلية',
  eServices: 'الخدمات الالكترنيه',
  verificationServices: 'خدمات التحقق',
  fetchingData: 'جاري تحميل البيانات',
  noDataFound: 'لا توجد بيانات متاحة',
  marriageOfficials: 'المأذونين',
  marriageOfficialLicense: 'ترخيص مأذون',
  licenseRequests: 'طلبات الترخيص',
  noLicensesFound: 'لا توجد تراخيص متاحة',
  noRequestsFound: 'لا توجد طلبات متاحة',
  newRequest: 'طلب جديد',
  procedures: 'إجراءات',
  marriageOfficialGuide: 'دليل مأذوني الأنكحة',
  licensorsGuide: 'دليل المرخصين',
  requestNewAuthorizedLicense: 'تقديم طلب رخصة مأذون أنكحة',
  editNewAuthorizedLicenseRequest: 'تعديل طلب رخصة مأذون أنكحة',
  previewNewAuthorizedLicenseRequest: 'معاينة طلب رخصة مأذون أنكحة',
  renewLicenseRequest: 'طلب  تجديد رخصة مأذون أنكحة ',
  editRenewLicenseRequest: 'تعديل طلب  تجديد رخصة مأذون أنكحة',
  previewRenewLicenseRequest: 'معاينة طلب  تجديد رخصة مأذون أنكحة ',
  reregisterLicenseRequest: 'طلب إعادة قيد',
  editReregisterLicenseRequest: 'تعديل طلب إعادة قيد',
  previewReregisterLicenseRequest: 'معاينة طلب إعادة قيد ',
  reissueLicenseRequest: 'إعادة إصدار رخصة مأذون أنكحة',
  editReissueLicenseRequest: 'تعديل طلب إعادة إصدار رخصة مأذون أنكحة',
  previewReissueLicenseRequest: 'معاينة طلب إعادة إصدار رخصة مأذون أنكحة',
  newLicenseRequest: 'طلب رخصة مأذون ',
  cancelLicenseRequest: 'شطب ترخيص مأذون',
  cancelLicenseRequestDetails: 'تفاصيل شطب الترخيص',
  applicantPersonalInfo: 'البيانات الشخصية لمقدم الطلب',
  personalInfo: 'البيانات الشخصية',
  requestReview: 'معاينة الطلب',
  viewRequestDetails: 'استعراض الطلب',
  theName: 'الاسم',
  anotherContactPerson: ['الشخص الاول', 'الشخص الثانى'],
  idNumber: 'رقم الهوية',
  dateOfBirth: 'تاريخ الميلاد',
  phone: 'رقم الجوال',
  email: 'البريد الإلكتروني',
  socialMediaAccounts: 'حسابات التواصل الإجتماعي',
  twitterId: 'معرّف حساب منصة إكس',
  twitterConsent: 'أتعهد بأنه لايوجد لدي حساب في منصة إكس',
  facebookId: 'معرّف حساب فيس بوك',
  facebookConsent: 'أتعهد بأنه لايوجد لدي حساب في فيس بوك',
  contactInfo: 'بيانات التواصل',
  contactInfoTitle: 'شخصان يمكن الاتصال بهما',
  contactInfoDescription: 'أشخاص يمكن التواصل معهم في حال تعذر الوصول لصاحب الطلب ',
  alert: 'تنبيه',
  qualificationDescription: 'يشترط إرفاق مؤهل جامعي ( بكالوريوس ) في العلوم الشرعية',
  qualifications: 'المؤهلات العلمية',
  jobAndQualification: 'المؤهلات العلمية و الوظيفية',
  state: 'الدولة',
  degree: 'الدرجة العلمية',
  university: 'الجامعة',
  universityName: 'اسم الجامعة',
  college: 'الكلية',
  collegeName: 'اسم الكلية',
  specialization: 'التخصص',
  specializationName: 'اسم التخصص',
  jobTitle: 'المسمى  الوظيفي',
  qualificationDoc: 'صورة المؤهل',
  attachments: 'المرفقات',
  toUpdateYourNationalAddress: ' لتحديث بيانات العنوان الوطني',
  pleaseClickHere: ' الرجاء الضغط هنا ',
  fromHere: ' من هنا',
  personalImageTitle: 'صورة رسمية 6 * 4',
  residenceAddress: 'عنوان الإقامة',
  city: 'المدينة',
  neighborhood: 'الحي',
  street: 'الشارع',
  buildingNumber: 'رقم المبنى',
  additionalNumber: 'الرقم الاضافي',
  zipCode: 'الرمز البريدي',
  requestInfo: 'بيانات الطلب',
  viewRequest: 'عرض بيانات الطلب',
  editRequestView: 'تعديل بيانات الطلب',
  addQualification: 'إضافة مؤهل علمي',
  addTheQualification: 'إضافة المؤهل',
  saveText: 'حفظ',
  youDoNotHaveQualification: 'لا توجد لديك مؤهلات علمية',
  youCanAddOnlyOneQualification: 'يمكن إضافة مؤهل واحد فقط',
  certificateEquivalencyCopy: 'صورة معادلة الشهادة',
  personalPicture: 'صورة شخصية ملونة',
  academicQualificationCopy: 'صورة المؤهل العلمي',
  licenseSuspension: 'سبب إيقاف الرخصة',
  rejectionReason: 'قرار الرفض',
  edit: 'تعديل',
  pleaseAddQualifications: 'الرجاء إضافة مؤهل علمي',
  youDoNotHaveNationalAddress: 'لايوجد لديك عنوان وطني مسجل',
  youCanNotContiueRequestBecause: 'لا يمكنك إكمال الطلب : ( {reason} )',
  searchingForNationalAddresses: 'جاري البحث عن عنوان وطني ...',
  pleaseChooseYourAddress: 'الرجاء إختيار العنوان الوطني من القائمة أعلاه',
  chooseYourAddress: 'اختر العنوان الوطني',
  splWebsite: 'موقع البريد السعودي (سـبل) من هنا',
  youDoNotHaveNationalAddressMessage: 'عزيزي المستفيد تعذر إتمام طلبك لعدم وجود عنوان وطني خاص بك الرجاء إنشاء عنوان وطني عبر',
  notValidSelectedAddress: 'عزيزي المستفيد تعذر إتمام طلبك لعدم توفر جزء من معلومات العنوان الوطني الرجاء تحديث عنوانك الوطني عبر',
  saveAndNextText: 'حفظ ومتابعة',
  saveRequestText: 'تقديم الطلب',
  editRequestText: 'تعديل الطلب',
  backText: 'الرجوع',
  prevText: 'السابق',
  newRequestSubmittedSuccessfully: 'تم تقديم الطلب بنجاح',
  newRequestEdittedSuccessfully: 'تم تعديل الطلب بنجاح',
  renewRequestSubmittedSuccessfully: 'تم تقديم طلب تجديد الرخصة بنجاح',
  renewRequestEdittedSuccessfully: 'تم تعديل طلب تجديد الرخصة بنجاح',
  reregisterRequestSubmittedSuccessfully: 'تم تقديم طلب إعادة القيد بنجاح',
  reregisterRequestEdittedSuccessfully: 'تم تعديل طلب إعادة القيد بنجاح',
  renewRequest: 'طلب تجديد',
  reregisterRequest: 'طلب إعادة قيد',
  marriageOfficialLicenseCancellation: 'شطب رخصة مأذون',
  absherVerificationText: 'الرجاء ادخال رمز التحقق المرسل على رقم الجوال المسجل في أبشر',
  remainingOtpTime: 'الوقت المتبقي لانتهاء المدة المسموحة',
  resendOtp: 'إعادة إرسال رمز التحقق',
  verify: 'التحقق',
  cancellationReason: 'سبب الطلب',
  otpRegenerationFailed: 'فشل إرسال رمز التحقق',
  otpVerificationFailed: 'لم يتم التحقق بنجاح',
  cancellationDocument: 'إرفاق ملف',
  cancellationDocumentAlert: '(يرجى إرفاق شهادة الوفاة او مايفيد بتسليم الضبوط)',
  cancelRequestConfirmation: 'هل أنت متأكد من إلغاء الطلب؟',
  cancelRequestConfirmationText: 'بتأكيد الإلغاء لن يتم حفظ البيانات التي أدخلتها',
  cancelRequest: 'إلغاء الطلب',
  NoRejectionReasons: 'لايوجد أسباب لعرضها',
  downloadRequestDecision: 'تحميل قرار الرفض',
  confirm: 'تأكيد',
  yourAddressHasBeenUpdatedFromWasel: 'الرجاء العلم أنه تم تحديث بيانات العنوان من العنوان الوطني',
  reissueRequestSubmittedSuccessfully: 'تم تقديم طلب إعادة إصدار الرخصة بنجاح',
  reissueRequestEdittedSuccessfully: 'تم تعديل طلب إعادة إصدار الرخصة بنجاح',
  reissueRequest: 'طلب إعادة إصدار',
  authenticateMarriageContract: 'توثيق عقد زواج جديد',
  newMarriageOfficalsRequest: 'طلب ترخيص جديد',
  medicalExamination: ' الفحص الطبي',
  writtenTest: 'الاختبار التحريري',
  writtenTestText: 'إجراء الاختبار التحريري من مركز التدريب العدلي',
  medicalExaminationText: 'تعبئة إستمارة الفحص الطبي، يمكنك الحصول عليها',
  medicalExaminationError: 'لا يمكنك تحميل نسخه ورقيه',
  jobTitlePlaceholder: 'ادخل المسمى الوظيفي',
  mobilePlaceholder: '05xxxxxxxx',
  emailPlaceholder: 'مثال: name@domain.com',
  personalPhoto: 'الصورة الشخصية',
  socialAccounts: 'حسابات التواصل الإجتماعي',
  personName1: 'اسم الشخص الأول',
  personName2: 'اسم الشخص الثاني',
  personMobile1: 'رقم جوال الشخص الأول',
  personMobile2: 'رقم جوال الشخص الثاني',
  personName: 'اسم الشخص',
  pleaseChoose: 'الرجاء الأختيار',
  serviceDocuments: 'مستندات الخدمة',
  toCompleteTheRequestAttach: 'لتتمكن من إتمام الطلب يتوجب وجود المرفقات',
  iHaveRead: 'أقر بأني قرأت',
  termsAndConditions: 'الشروط والأحكام',
  socialAccountPlaceholder: 'معرّف الحساب',
  theAddress: 'العنوان',
  number: 'رقم',
  retreat: 'تراجع',
  confirmRequest: 'تأكيد الطلب',
  delete: 'حذف',
  cancelTheLicense: 'شطب الترخيص',
  cancelNotePlaceholder: 'أكتب سبب طلب شطب الترخيص',
  withMaxLengthChars: 'بحد أقصى {length} حرف',
  enterCodeSentToID: 'الرجاء إدخال الـ 4 أرقام المرسلة لرقم الجوال المسجل على الهوية رقم',
  cancellationRequestConfirmTitle: 'طلب شطب ترخيص مأذون رقم {licenseNumber}',
  cancellationRequestConfirmMessage: 'هل أنت متأكد من شطب الترخيص؟',
  editCancellationRequestConfirmMessage: 'هل أنت متأكد من تعديل شطب الترخيص؟',
  verification: 'التحقق',
  requestSuccededPlaceholderTitle: 'تم تقديم {requestTypeName} بنجاح',
  requestSuccededPlaceholderText: 'تم استقبال طلبك رقم {requestNumber} وسيتم اشعارك في حال تحديث حالة الطلب',
  requestDetails: 'تفاصيل الطلب',
  backToHome: 'العودة للرئيسية',
  viewRequestStatus: 'متابعة حالة الطلب',
  updateMarriageOfficialData: 'تحديث بيانات مأذون',
  updateLicenseRequest: 'تحديث بيانات مأذون',
  editUpdateLicenseRequest: 'تعديل طلب تحديث بيانات مأذون',
  previewUpdateLicenseRequest: 'معاينة طلب تحديث بيانات مأذون',
  chooseServiceType: 'اختر نوع الخدمة',
  updatePersonalInfo: 'تحديث البيانات الشخصية للمأذون',
  useService: 'استخدام الخدمة',
  updateNameRequest: 'تحديث اسم مأذون',
  editUpdateNameRequest: 'تعديل طلب تحديث اسم مأذون',
  previewUpdateNameRequest: 'معاينة طلب تحديث اسم مأذون',
  updateNameRequestSubmittedSuccessfully: 'تم تقديم طلب تحديث اسم مأذون بنجاح',
  updateNameRequestEdittedSuccessfully: 'تم تعديل طلب تحديث اسم مأذون بنجاح',
  updateOfficiantDataRequestSubmittedSuccessfully: 'تم تقديم طلب تحديث بيانات مأذون بنجاح',
  updateOfficiantDataRequestEdittedSuccessfully: 'تم تعديل طلب تحديث بيانات مأذون بنجاح',
  backToLicenses: 'عودة إلى التراخيص',
  updateNameNotification: 'إشعار تحديث الاسم',
  updateNameNotificationAttachment: 'مرفق إشعار تحديث الاسم',
  personalPhotoHelperText: 'نوع الملف يجب أن يكون ( jfif - pjpeg - jpeg - pjp - jpg - png  )  وبحجم 1 م.ب كحد أقصى',
  requestAttachmentHelperText: 'نوع الملف يجب أن يكون ( pdf - jfif - pjpeg - jpeg - pjp - jpg - png  )  وبحجم 5 م.ب كحد أقصى',
  qualificationAttachmentHelperText: 'نوع الملف يجب أن يكون ( pdf - jfif - pjpeg - jpeg - pjp - jpg - png  )  وبحجم 5 م.ب كحد أقصى',
  deleteQualificationConfirmation: 'حذف المؤهل؟',
  deleteQualificationConfirmationText: 'هل انت متأكد من حذف المؤهل “{name}”؟',
  sendTheRequest: 'إرسال الطلب',
  nationalAddressAlertTitle: 'تعذر  إتمام الخدمة',
  noResultFound: 'لا يوجد نتائج تطابق البيانات المدخلة',
  pleaseVerifyYourInputs: 'الرجاء التأكد من البيانات، والمحاولة مجدداً.',
  nafathVerification: 'التحقق عبر نفاذ',
  validations: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    maxInputsLength: 'أقصى عدد للمدخلات هو {length}',
    numbersExactLength: ' عدد الأرقام يجب أن يكون {length}',
    startsWith: ' يجب أن يبدأ ب {listText}',
    phoneNumber: 'يجب أن يبدأ رقم الجوال ب {key} وأن يكون {length} أرقام',
    emailAddress: 'الرجاء إدخال بريد إلكتروني صحيح',
    onlyArabicAndNumbers: 'الرجاء إدخال أحرف عربية وأرقام فقط.',
    onlyArabicOrNumbers: 'الرجاء إدخال أحرف عربية أو أرقام فقط.',
    specialCharacters: 'الرجاء عدم إدخال رموز خاصة.',
    twitterId: 'يجب أن يكون المعرف كالآتي http(s)://twitter.com/xyz123',
    facebookId: 'يجب أن يكون المعرف كالآتي http(s)://facebook.com/xyz123',
    minWordsLength: 'أقل عدد للكلمات يجب أن يكون {length}',
    theNameMustBeBinary: 'يجب أن يكون الإسم ثنائياً',
    onlyArabic: 'يجب إدخال أحرف عربية فقط',
    duplicatePhoneNumberInContactInfo: 'يجب أن لايتطابق رقم الشخص الأول مع الشخص الثاني',
    duplicatePhoneNumberInApplicantInfo: 'يجب أن لايتطابق رقم الجوال مع رقم الجوال في البيانات الشخصية',
    alphaNumeric: 'الرجاء إدخال أحرف إنجليزية وأرقام  فقط.',
    alphaNumericAndSpecialChars: 'الرجاء إدخال أحرف إنجليزية وأرقام ورموز خاصة مثل {chars}',
  },
  marriageOfficialList: {
    licenceNumber: 'رقم الترخيص',
    licenceType: 'نوع الترخيص',
    licenceStatus: 'حالة الترخيص',
    licenseSearch: 'ابحث برقم الترخيص',
    creationDate: 'تاريخ الاصدار',
    expiryDate: 'تاريخ الانتهاء',
    title: 'ترخيص مأذون',
    active: 'ساري',
    inActive: 'غير ساري',
    licenseDetails: 'تفاصيل الترخيص',
    downloadLicense: 'تحميل الترخيص',
  },
  licenseAndDetails: {
    licenseNumber: 'رقم الترخيص',
    licenseType: 'نوع الترخيص',
    licenseStatus: 'حالة الترخيص',
    creationDate: 'تاريخ الاصدار',
    expiryDate: 'تاريخ الانتهاء',
    title: 'ترخيص مأذون',
    active: 'ساري',
    inActive: 'غير ساري',
    licenseDetails: 'تفاصيل الترخيص',
    downloadLicense: 'تحميل الترخيص',
    softLicenseCopy: 'لا يمكن تحميل نسخة من الترخيص الورقي',
    issueLicense: 'إصدار الرخصة',
    requestRecieved: 'تم استلام الطلب',
    requestApproved: 'تمت الموافقة',
    requestSteps: 'مراحل الطلب',
    backToRequests: 'عودة إلى قائمة الطلبات',
    reIssueLicense: 'إعادة اصدار الترخيص',
  },
  marriageOfficialRequestsList: {
    reIssueLicense: ' إعادة إصدار الترخيص',
    requestNumber: 'رقم الطلب',
    requestDate: 'تاريخ الطلب',
    requestType: 'نوع الطلب',
    requestStatus: 'حالة الطلب',
    view: 'معاينة الطلب',
    viewLicense: 'معاينة الترخيص',
    edit: 'تعديل بيانات الطلب',
    uncompleteResons: 'أسباب عدم الإكتمال',
    delete: 'حذف الطلب',
    newRequest: 'طلب ترخيص جديد',
    renewLicenseRequest: 'طلب تجديد رخصة',
    renewLicense: 'تجديد رخصة مأذون',
    viewRejectionReasons: 'أسباب الرفض',
    editCancelRequest: 'تعديل طلب الشطب',
    reRegisterLicense: 'إعادة قيد رخصة مأذون',
    cancelLicneseRequest: 'طلب شطب رخصة',
    cancelLicnese: 'شطب الترخيص',
    reissuelLicnese: 'طلب إعادة إصدار ترخيص',
    requestMarriageOfficalLicense: 'طلب رخصة مأذون',
    reIssueMarriageOfficalLicense: 'إعادة إصدار مأذون',
    updateMarriageOfficalData: 'تحديث بيانات مأذون',
    updateMarriageOfficalName: 'تحديث اسم مأذون',
    renewMarriageOfficalLicense: 'تجديد رخصة مأذون',
    reRegisterMarriageOfficalLicense: 'إعادة قيد ترخيص مأذون',
    viewClosingReasons: 'أسباب إغلاق الطلب',

    requestTypeCompleted: 'مكتمل',
    requestTypeReturenToComplete: 'معاد للاستكمال',
    requestTypeInProcessing: 'قيد المعالجة',
    requestTypeUnderReview: 'قيد المراجعة',
    requestTypeCanceled: 'ملغي',
    requestTypeRejected: 'مرفوض',
    requestTypeDraft: 'مسودة',
    requestTypeNew: 'جديد',
    requestTypeInComplete: 'غير مكتمل',
    requestsSearch: 'ابحث برقم الطلب',
    sortAs: 'ترتيب حسب',
  },
  marriageOfficicalsGuide: {
    mobile: 'الجوال',
    address: 'العنوان',
    contractType: 'نوع العقد',
    court: 'المحكمة',
    loadCities: 'تحميل المدن',
    loadDistricts: 'تحميل الاحياء',
    loadMarriageOfficials: 'تحميل مأذوني الانكحة',
    licenseStatus: 'ترخيص ساري',
    licenseNumber: 'رقم الترخيص',
  },
  telemetry: {
    submitReissueRequest: 'تقديم طلب إعادة إصدار رخصة',
    licensesRequests: 'طلبات التراخيص',
    marriageOfficialsLicenses: 'تراخيص المأذون',
    submitNewRequest: 'تقديم طلب ترخيص جديد',
    submitRenewRequest: 'تقديم طلب تجديد ترخيص ',
    submitReregisterRequest: 'تقديم طلب إعادة ترخيص',
    fetchRequestDetails: 'تحميل بيانات الطلب',
    fetchLicenseData: 'تحميل بيانات الرخصة',
    licenseCancellation: 'طلب شطب رخصة مأذون',
    licenseCancellationPreview: 'استعراض طلب شطب رخصة مأذون',
    licenseDetailsPreview: 'استعراض تفاصيل الرخصة',
    submitUpdateRequest: 'تقديم طلب تحديث بيانات مأذون ',
    submitUpdateNameRequest: 'تقديم طلب تحديث اسم مأذون ',
  },
  requestStatusesMessages: {
    fallback: 'خطأ: تعذر الحصول على الحالة.',
    new: 'طلب جديد',
    canceled: 'ملغي لعدم الرد',
    approved: 'الطلب مكتمل',
    reviewPapers: 'مراجعة الاوراق',
    rejected: 'تم رفض الطلب',
    processing: 'تم استلام الطلب',
    pendingCommitteeHead: 'بانتظار موافقة رئيس اللجنة',
    returnedToComplete: 'الطلب معاد للإستكمال',
    underProcess: 'الطلب تحت المعالجة',
    changeFromClient: 'تم التعديل من قبل المستفيد',
    incomplete: 'غير مكتمل',
    approveFromjudicialLicense: 'بانتظار موافقة نظام التراخيص',
    underReview: 'الطلب قيد المراجعة',
    closed: 'تم إغلاق الطلب',
  },
  serverErrors: {
    NOT_FOUND: 'لا يمكننا خدمتك  في الوقت الحالي. الرجاء المحاولة لاحقاً',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
    LICENSE_DOCUMENT_NOT_FOUND: 'لا يمكن عرض نسخة من الترخيص الورقي',
  },
  pleaseUpdateOneFieldToCompleRequest: 'الرجاء التحديث على حقل واحد على الأقل لإتمام طلبكم',
};
export default ar;
